export const BASE_COMMENT_HEIGHT = 25;

export const commentTypes = {
  ADD: 'comment-add',
  EDIT: 'comment-edit',
  REPLY: 'comment-reply'
};
